import { dynamicFailed } from "../hooks/useToast";
import { IComplaint } from "../exports/interfaces";
import axiosClient from "../axioxClient.ts/axiosClient";
import { checkNullDate } from "../exports/functions";

export const fetchComplaints = async (): Promise<IComplaint[]> => {
  try {
    const response = await axiosClient.get<IComplaint[]>("/complaints");

    return response.data
      .map((complaint) => ({
        ...complaint,
        filedOn: checkNullDate(complaint.filedOn),
      }))
      .sort(
        (a, b) =>
          new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
      );
  } catch (error) {
    throw error;
  }
};

export const fetchComplaintById = async (
  id: number,
): Promise<IComplaint | null> => {
  try {
    const response = await axiosClient.get<IComplaint>(`/complaints/${id}`);

    return {
      ...response.data,
      filedOn: checkNullDate(response.data.filedOn),
    };
  } catch (error: any) {
    const message = error?.response?.data?.message || "Something went wrong!";

    dynamicFailed(message);
    return null;
  }
};
